<template>
  <div class="payment">
    <div class="con1">
      <div class="line1">Payment Details:</div>
      <div class="paymentDetail">
        <!-- <div class="item">Deposit Reference:<span>1234.00$</span></div>
        <div class="item">Deposit Method:<span>Deposit Method</span></div> -->
        <div class="item">Order Number:<span>{{orderDetail.order_number}}</span></div>
        <div class="item">Deposit Settle Time:<span>{{orderDetail.payment.pay_time}}</span></div>
        <div class="item">Payment amount:<span>${{orderDetail.payment.paid}}</span></div>
        <!-- <div class="item">Currency:<span>Currency</span></div>
        <div class="item">Card Number:<span>1234 1234 1234</span></div>
        <div class="item">Expected Paymen Date:<span>Expected Paymen Date</span></div> -->
      </div>
    </div>
    <!-- <div class="con2">
      <div class="line1">Recieve account:</div>
      <div class="paymentDetail">
        <div class="item">Account Number:<span>1234 1234 1234 1234</span></div>
        <div class="item">Redeem Type:<span>WeChat</span></div>
        <div class="item">Reference:<span>Reference</span></div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'payment',
  props: ['orderDetail'],
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.payment {
  .con1,
  .con2 {
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 10px;
    .line1 {
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      line-height: 21px;
    }
    .paymentDetail {
      margin-top: 20px;
      .item {
        margin-top: 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9c9c9c;
        span {
          margin-left: 15px;
          color: #000000;
        }
        .concrete {
          margin-top: 20px;
          color: #000000;
          line-height: 22px;
        }
      }
    }
  }
  .con2 {
    margin-top: 40px;
  }
}
</style>
